import { useEffect } from 'react';

const DOMAIN = 'https://bodybycc.fr';

export interface BreadcrumbItem {
  name: string;
  path: string;
}

/**
 * Injects a BreadcrumbList JSON-LD script into <head>.
 * Automatically prepends "Accueil" as first item.
 * Cleans up on unmount.
 */
export function useBreadcrumbSchema(items: BreadcrumbItem[]) {
  useEffect(() => {
    const allItems: BreadcrumbItem[] = [{ name: 'Accueil', path: '/' }, ...items];

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: allItems.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: `${DOMAIN}${item.path}`,
      })),
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-breadcrumb', 'true');
    script.textContent = JSON.stringify(jsonLd);

    // Remove any existing breadcrumb schema
    document.querySelectorAll('script[data-breadcrumb]').forEach((el) => el.remove());
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [items]);
}
